/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Achievementssetslabel2Inputs */

const id_sandboxes_achievementssetslabel2 = /** @type {(inputs: Sandboxes_Achievementssetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set`)
};

const ms_sandboxes_achievementssetslabel2 = /** @type {(inputs: Sandboxes_Achievementssetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set`)
};

const da_sandboxes_achievementssetslabel2 = /** @type {(inputs: Sandboxes_Achievementssetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sæt`)
};

const de_sandboxes_achievementssetslabel2 = /** @type {(inputs: Sandboxes_Achievementssetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets`)
};

const en_us2_sandboxes_achievementssetslabel2 = /** @type {(inputs: Sandboxes_Achievementssetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets`)
};

const es_es2_sandboxes_achievementssetslabel2 = /** @type {(inputs: Sandboxes_Achievementssetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conjuntos`)
};

const es_mx2_sandboxes_achievementssetslabel2 = /** @type {(inputs: Sandboxes_Achievementssetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conjuntos`)
};

const fil_sandboxes_achievementssetslabel2 = /** @type {(inputs: Sandboxes_Achievementssetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Set`)
};

const fr_sandboxes_achievementssetslabel2 = /** @type {(inputs: Sandboxes_Achievementssetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ensembles`)
};

const it_sandboxes_achievementssetslabel2 = /** @type {(inputs: Sandboxes_Achievementssetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set`)
};

const hu_sandboxes_achievementssetslabel2 = /** @type {(inputs: Sandboxes_Achievementssetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Készletek`)
};

const nl_sandboxes_achievementssetslabel2 = /** @type {(inputs: Sandboxes_Achievementssetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets`)
};

const no_sandboxes_achievementssetslabel2 = /** @type {(inputs: Sandboxes_Achievementssetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sett`)
};

const pl_sandboxes_achievementssetslabel2 = /** @type {(inputs: Sandboxes_Achievementssetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zestawy`)
};

const pt_br2_sandboxes_achievementssetslabel2 = /** @type {(inputs: Sandboxes_Achievementssetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conjuntos`)
};

const pt_sandboxes_achievementssetslabel2 = /** @type {(inputs: Sandboxes_Achievementssetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conjuntos`)
};

const ro_sandboxes_achievementssetslabel2 = /** @type {(inputs: Sandboxes_Achievementssetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seturi`)
};

const fi_sandboxes_achievementssetslabel2 = /** @type {(inputs: Sandboxes_Achievementssetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sarjat`)
};

const sv_sandboxes_achievementssetslabel2 = /** @type {(inputs: Sandboxes_Achievementssetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uppsättningar`)
};

const vi_sandboxes_achievementssetslabel2 = /** @type {(inputs: Sandboxes_Achievementssetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bộ`)
};

const tr_sandboxes_achievementssetslabel2 = /** @type {(inputs: Sandboxes_Achievementssetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setler`)
};

const cs_sandboxes_achievementssetslabel2 = /** @type {(inputs: Sandboxes_Achievementssetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sady`)
};

const bg_sandboxes_achievementssetslabel2 = /** @type {(inputs: Sandboxes_Achievementssetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Набори`)
};

const ru_sandboxes_achievementssetslabel2 = /** @type {(inputs: Sandboxes_Achievementssetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наборы`)
};

const uk_sandboxes_achievementssetslabel2 = /** @type {(inputs: Sandboxes_Achievementssetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Набори`)
};

const ar_sandboxes_achievementssetslabel2 = /** @type {(inputs: Sandboxes_Achievementssetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المجموعات`)
};

const hi_sandboxes_achievementssetslabel2 = /** @type {(inputs: Sandboxes_Achievementssetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेट`)
};

const th_sandboxes_achievementssetslabel2 = /** @type {(inputs: Sandboxes_Achievementssetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชุด`)
};

const ja_sandboxes_achievementssetslabel2 = /** @type {(inputs: Sandboxes_Achievementssetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セット`)
};

const zh_cn2_sandboxes_achievementssetslabel2 = /** @type {(inputs: Sandboxes_Achievementssetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集合`)
};

const zh_hant1_sandboxes_achievementssetslabel2 = /** @type {(inputs: Sandboxes_Achievementssetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集合`)
};

const ko_sandboxes_achievementssetslabel2 = /** @type {(inputs: Sandboxes_Achievementssetslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`세트`)
};

/**
* | output |
* | --- |
* | "Sets" |
*
* @param {Sandboxes_Achievementssetslabel2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_achievementssetslabel2 = /** @type {((inputs?: Sandboxes_Achievementssetslabel2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Achievementssetslabel2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_achievementssetslabel2(inputs)
	if (locale === "ms") return ms_sandboxes_achievementssetslabel2(inputs)
	if (locale === "da") return da_sandboxes_achievementssetslabel2(inputs)
	if (locale === "de") return de_sandboxes_achievementssetslabel2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_achievementssetslabel2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_achievementssetslabel2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_achievementssetslabel2(inputs)
	if (locale === "fil") return fil_sandboxes_achievementssetslabel2(inputs)
	if (locale === "fr") return fr_sandboxes_achievementssetslabel2(inputs)
	if (locale === "it") return it_sandboxes_achievementssetslabel2(inputs)
	if (locale === "hu") return hu_sandboxes_achievementssetslabel2(inputs)
	if (locale === "nl") return nl_sandboxes_achievementssetslabel2(inputs)
	if (locale === "no") return no_sandboxes_achievementssetslabel2(inputs)
	if (locale === "pl") return pl_sandboxes_achievementssetslabel2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_achievementssetslabel2(inputs)
	if (locale === "pt") return pt_sandboxes_achievementssetslabel2(inputs)
	if (locale === "ro") return ro_sandboxes_achievementssetslabel2(inputs)
	if (locale === "fi") return fi_sandboxes_achievementssetslabel2(inputs)
	if (locale === "sv") return sv_sandboxes_achievementssetslabel2(inputs)
	if (locale === "vi") return vi_sandboxes_achievementssetslabel2(inputs)
	if (locale === "tr") return tr_sandboxes_achievementssetslabel2(inputs)
	if (locale === "cs") return cs_sandboxes_achievementssetslabel2(inputs)
	if (locale === "bg") return bg_sandboxes_achievementssetslabel2(inputs)
	if (locale === "ru") return ru_sandboxes_achievementssetslabel2(inputs)
	if (locale === "uk") return uk_sandboxes_achievementssetslabel2(inputs)
	if (locale === "ar") return ar_sandboxes_achievementssetslabel2(inputs)
	if (locale === "hi") return hi_sandboxes_achievementssetslabel2(inputs)
	if (locale === "th") return th_sandboxes_achievementssetslabel2(inputs)
	if (locale === "ja") return ja_sandboxes_achievementssetslabel2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_achievementssetslabel2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_achievementssetslabel2(inputs)
	return ko_sandboxes_achievementssetslabel2(inputs)
});
export { sandboxes_achievementssetslabel2 as "sandboxes.achievementsSetsLabel" }